import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { useAppDispatch } from '../hooks/reduxHooks';
import Loader from '../components/Loader';
import {
  addTrialObjToStore,
  setDigitalCases,
  setDigitalQuestions,
  setDigitalSections,
  setDigitalSurvey,
  setQuestionCaseSettings,
} from '../redux/actions';
import ApiClient from '../loopback/apiClient';
import withRouter from '../hoc/withRouter';
import { ExtendedDigitalSurvey } from '../redux/types';

const ReviewPublicSurveyView = ({
  addTrialObjToStore: addTrialObjToStoreAction,
  setDigitalSurvey: setDigitalSurveyAction,
  setDigitalSections: setDigitalSetionsAction,
  setDigitalQuestions: setDigitalQuestionsAction,
  setDigitalCases: setDigitalCasesAction,
  setQuestionCaseSettings: setQuestionCaseSettingsAction,
}: PropsFromRedux) => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      return;
    }
    const fetchResolvePublicLinks = async () => {
      const trial = await ApiClient.resolvePublicLinks(token);
      let routeUrl = '';
      const { version = 1 } = trial;
      if (version < 2) {
        addTrialObjToStoreAction(trial);
        routeUrl = `/survey/${trial.id}`;
      } else if (version >= 2) {
        const { digitalSurveys } = trial;
        if (!digitalSurveys) {
          return;
        }
        const filterDigitalSurvey = digitalSurveys.filter(
          (ds: ExtendedDigitalSurvey) => !ds.exercise,
        )[0];
        const {
          digitalQuestions,
          digitalSections,
          digitalCases = [],
          questionCaseSettings = [],
          ...digitalSurvey
        } = filterDigitalSurvey;
        dispatch(setDigitalSurveyAction(digitalSurvey));
        dispatch(setDigitalSetionsAction(digitalSections));
        dispatch(setDigitalCasesAction(digitalCases));
        dispatch(setDigitalQuestionsAction(digitalQuestions));
        dispatch(setQuestionCaseSettingsAction(questionCaseSettings));
        routeUrl = `/trial/${trial.id}/survey?public=true`;
      }
      navigate(routeUrl);
    };
    fetchResolvePublicLinks();
  }, [
    token,
    navigate,
    dispatch,
    addTrialObjToStoreAction,
    setDigitalSurveyAction,
    setDigitalQuestionsAction,
    setDigitalCasesAction,
    setDigitalSetionsAction,
    setQuestionCaseSettingsAction,
  ]);

  return <Loader isLoading text="Loading survey" />;
};

const dispatchProps = {
  addTrialObjToStore,
  setDigitalSurvey,
  setDigitalSections,
  setDigitalQuestions,
  setDigitalCases,
  setQuestionCaseSettings,
};

const connector = connect(null, dispatchProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(withRouter(ReviewPublicSurveyView));
